'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

import { CustomerSurfaceError } from '@/components/customer-surface/CustomerSurface';
import { useReportRouteError } from '@/lib/client/observability/use-report-route-error';

// A thrown render/data error used to fall through to Next's default error page:
// an unstyled, unbranded wall of text with a "try again" that most guests never
// find. This keeps them inside the product with one obvious recovery action.
export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  const pathname = usePathname();

  useReportRouteError(error, { route: pathname });

  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <CustomerSurfaceError
      title="We couldn’t load this page"
      message="Try again in a moment."
      onRetry={reset}
    />
  );
}
